<template>
<div>
  <h4> {{$t('leads.details.questionary')}} </h4>
  <div v-if="answers" class="mt-4 mb-3">
    <div v-for="answer in answers" :key="answer.id">
      <div class="d-flex q-a">
      <div class="col-12 col-md-10">
        <span class="q-a question">
          <p>{{answer.question}}</p>
        </span>
      </div>
      <div class="col-12 col-md-2">
        <span class="q-a answer">
          <p>{{answer.answer}}</p>
        </span>
      </div>
      </div>
      <hr class="separator">
    </div>
  </div>
  <div v-else>
    {{$t('leads.details.no_answer')}}
  </div>
</div>
</template>
<script>
export default {
  props: ['answers']
}
</script>

<style lang="scss" scoped>

  .q-a {
    margin: 0.2rem;
    p {
      margin-top: 0.3rem;
      margin-bottom: 0.3rem;
    }
  }

  .question {
    // width: 85%;
    width: calc(100% - 85px);
    margin-right: 0.5rem;
  }

  .answer p {
    color: $evollu-dark;
    font-weight: bold;
  }

  .separator {
    margin: 0.2rem;
  }
</style>
